import { trigger, state, animate, transition, style } from '@angular/animations';

export function fadeIn(stateStart: string, stateEnd: string) {
  return trigger('fadeIn', [
    state(
      `${stateStart}`,
      style({
        opacity: 0.2
      })
    ),
    state(
      `${stateEnd}`,
      style({
        opacity: 1
      })
    ),
    transition(`${stateStart} => ${stateEnd}`, animate('500ms ease-in')),
    transition(`${stateEnd} => ${stateStart}`, animate('500ms ease-out'))
  ]);
}
